/** Route resolvers — centralize the "premium users get /p/{slug}" logic. */

export const authorHref = (userOrPhoto) => {
  if (!userOrPhoto) return "/";
  // Photo payloads expose user_is_premium; user payloads expose is_premium
  const premium =
    userOrPhoto.user_is_premium ??
    userOrPhoto.is_premium ??
    false;
  const slug = userOrPhoto.portfolio_slug;
  const id = userOrPhoto.user_id ?? userOrPhoto.id;
  if (premium && slug) return `/p/${slug}`;
  return id ? `/profile/${id}` : "/";
};

export const portfolioHref = (user) => {
  if (!user) return "/";
  if (user.is_premium && user.portfolio_slug) return `/p/${user.portfolio_slug}`;
  return `/profile/${user.id}`;
};
